import * as tslib_1 from "tslib";
import React from 'react';
import { noop, get, isNil } from 'lodash';
import PropTypes from 'prop-types';

var withFocusedState = function withFocusedState(WrappedComponent) {
  var _a;

  return _a =
  /** @class */
  function (_super) {
    tslib_1.__extends(WithFocusedState, _super);

    function WithFocusedState() {
      var _this = _super !== null && _super.apply(this, arguments) || this;

      _this.state = {
        focused: false
      };

      _this.updateFocused = function (value) {
        return _this.setState({
          focused: value
        });
      };

      _this.onFocus = function (event) {
        var _a = _this.props,
            disabled = _a.disabled,
            onFocus = _a.onFocus,
            autoFocus = _a.autoFocus;
        if (disabled) return;

        if (autoFocus && !isNil(get(event, 'target.value'))) {
          var target = event.target;
          var value = target.value.toString();
          target.selectionStart = value.length;
          target.selectionEnd = value.length;
        }

        _this.updateFocused(true);

        onFocus(event);
      };

      _this.onBlur = function (event) {
        var _a = _this.props,
            disabled = _a.disabled,
            onBlur = _a.onBlur;
        if (disabled) return;

        _this.updateFocused(false);

        onBlur(event);
      };

      return _this;
    }

    WithFocusedState.prototype.componentDidMount = function () {
      if (this.props.autoFocus) {
        this.updateFocused(true);
      }
    };

    WithFocusedState.prototype.componentWillReceiveProps = function (nextProps) {
      if (nextProps.disabled && this.state.focused) {
        this.updateFocused(false);
      }
    };

    WithFocusedState.prototype.render = function () {
      return React.createElement(WrappedComponent, tslib_1.__assign({}, this.props, {
        focused: this.state.focused,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }));
    };

    return WithFocusedState;
  }(React.Component), _a.propTypes = tslib_1.__assign({}, WrappedComponent.propTypes, {
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }), _a.defaultProps = tslib_1.__assign({}, WrappedComponent.defaultProps, {
    onFocus: noop,
    onBlur: noop
  }), _a;
};

export default withFocusedState;

try {
  // @ts-ignore
  withFocusedState.__docgenInfo = {
    "description": "",
    "displayName": "withFocusedState",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}